import { InvokeCallback, Sender } from "xstate";
import {
  CreateOrUpdateBookingParams,
  updateBooking,
} from "@rentablo/api/apiv1";
import { withToken } from "@rentablo/api";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";

export const updateDividend =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  (callback) => {
    // if (event.type !== "PERSIST") {
    //   throw new Error(`Invalid event type ${event.type}`);
    // }

    if (!context.bookingId) {
      throw new Error(`Invalid booking id: ${context.bookingId}`);
    }

    // TODO: need refactor this types checking
    if (
      !context.validatedMultipleBookingParams
        ?.createOrUpdateInvestmentParamsList![0]
        .createOrUpdateBookingParamsList![0]
    ) {
      throw new Error("Invalid booking param list");
    }

    const [params] =
      context.validatedMultipleBookingParams
        .createOrUpdateInvestmentParamsList[0].createOrUpdateBookingParamsList;

    update(context.bookingId, params, callback);
  };

const update = async (
  bookingId: number,
  params: CreateOrUpdateBookingParams,
  callback: Sender<DividendWizardEvent>
) => {
  try {
    await withToken(updateBooking)({
      id: bookingId,
      createOrUpdateBookingParams: params,
    });

    callback({ type: "SUCCESS" });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
